export const PROVINCES = [
  { value: '15', name: 'Lima', region: 'Lima' },
  { value: '01', name: 'Amazonas', region: 'Norte' },
  { value: '02', name: 'Ancash', region: 'Norte' },
  { value: '03', name: 'Apurímac', region: 'Sur' },
  { value: '04', name: 'Arequipa', region: 'Sur' },
  { value: '05', name: 'Ayacucho', region: 'Sur' },
  { value: '06', name: 'Cajamarca', region: 'Norte' },
  { value: '08', name: 'Cusco', region: 'Sur' },
  { value: '09', name: 'Huancavelica', region: 'Sur' },
  { value: '10', name: 'Huánuco', region: 'Centro' },
  { value: '11', name: 'Ica', region: 'Centro' },
  { value: '12', name: 'Junín', region: 'Centro' },
  { value: '13', name: 'La Libertad', region: 'Norte' },
  { value: '14', name: 'Lambayeque', region: 'Norte' },
  { value: '16', name: 'Loreto', region: 'Norte' },
  { value: '17', name: 'Madre de Dios', region: 'Sur' },
  { value: '18', name: 'Moquegua', region: 'Sur' },
  { value: '19', name: 'Pasco', region: 'Centro' },
  { value: '20', name: 'Piura', region: 'Norte' },
  { value: '21', name: 'Puno', region: 'Sur' },
  { value: '22', name: 'San Martín', region: 'Norte' },
  { value: '23', name: 'Tacna', region: 'Sur' },
  { value: '24', name: 'Tumbes', region: 'Norte' },
  { value: '25', name: 'Ucayali', region: 'Centro' },
];
